// extracted by mini-css-extract-plugin
module.exports = {"prefectureDrillDown__checkbox":"prefectureDrillDown__checkbox"};